import React, {Component} from 'react';

const TITLES= [
    'I am a Competitve Programmer',
    'I create (My name literally stands for creator)',
    'A Pop and Country music lover',
    'Let\'s hang out over Coffee? '
];

class Title extends Component {

    state = { titleIndex : 0 , fadeIn:true };

    componentDidMount(){

        setTimeout(()=>this.setState({fadeIn:false}),2000);
        console.log("The title component has mounted");

        this.animateTitles();
    }

    animateTitles = () => {
        setInterval( () => {
            const titleIndex = (this.state.titleIndex + 1);
            if(titleIndex>3)titleIndex=0;

            this.setState({titleIndex,fadeIn:true})

            setTimeout(()=>this.setState({fadeIn:false}),2000);
        } , 4000);
    }

    render(){

        const {fadeIn , titleIndex} = this.state;

        const title = TITLES[this.state.titleIndex];

        return(
            <p  className={fadeIn? 'title-fade-in' : 'title-fade-out'}>{title}</p>
        )
    }
}

export default Title;